import axios from "axios";
import { notification } from "ant-design-vue";

function request(options) {
  return axios(options)
    .then(res => {
      return res;
    })
    .catch(error => {
      console.log('request error: ',error);
      if(ReturnCode in error){
        const {
          response: { ReturnCode }
        } = error;
        notification.error({
          // eslint-disable-next-line no-unused-vars
          message: h => (
            <div>
              请求错误 <span style="color: red">{ReturnCode}</span> : {options.url}
            </div>
          ),
          description: ReturnCode
        });        
      } 
      else {
        notification.error({
          // eslint-disable-next-line no-unused-vars
          message: h => (
            <div>
              {error}
            </div>
          ),
          description: "network error"
        });
      }
      return Promise.reject(error);
    });
}

export default request;
